import { EALogsResponse } from "../types";
import logjson from "./assets/logs.json";

export const fakeLogs = logjson as EALogsResponse["assistantLogs"] | [];
